import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface SidebarDetailsRowProps {
    title: string;
    text?: string;
    color?: string;
    italic?: boolean;
}

export const SidebarDetailsRow = ({
    title,
    text,
    color = "success.main",
    italic,
}: SidebarDetailsRowProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            <Box
                sx={{
                    textAlign: "left",
                    fontStyle: italic ? "italic" : undefined,
                }}
            >
                <Typography sx={{ color: italic ? "gray.main" : "dark.main" }}>
                    {title}
                </Typography>
            </Box>
            {!!text ? (
                <Box
                    sx={{
                        textAlign: "right",
                        whiteSpace: "nowrap",
                    }}
                >
                    <Typography sx={{ color }}>{text}</Typography>
                </Box>
            ) : null}
        </Box>
    );
};
